import { useExportEvents, BaseExportEvent } from './useExportEvents';
import { APIBaseChronos } from '@/api/hosts';

export interface DocumentZipEvent extends BaseExportEvent {
  type: 'document-zip-progress' | 'document-zip-complete' | 'document-zip-error' | string;
  jobType: 'document-zip';
  caseId: string;
  unsupportedAttachments?: Array<{
    filename: string;
    extension: string;
  }>;
  parentEmailName?: string;
}

interface UseDocumentZipEventsProps {
  caseId: string;
  onEvent: (event: DocumentZipEvent) => void;
  enabled?: boolean;
}

/**
 * Hook for subscribing to document zip progress events.
 * Uses a persistent SSE connection that listens to ALL document zip events for a case.
 */
export const useDocumentZipEvents = ({ caseId, onEvent, enabled = true }: UseDocumentZipEventsProps) => {
  return useExportEvents<DocumentZipEvent>({
    progressEndpoint: `${APIBaseChronos}/api/storage/document-zip-events/${caseId}`,
    onEvent,
    enabled: enabled && !!caseId,
    // Document zip events don't have a status check endpoint
    // The SSE stream stays connected and listens for all events
    skipInitialStatusCheck: true,
  });
};
